:host {
  display: block;

  .search-facet__headline {
    display: flex;
    justify-content: space-between;
    align-content: center;
    margin-bottom: 20px;

    > * {
      display: inline-flex;
    }
  }

  ui-input {
    margin-bottom: 5px;
  }
}
